import React from 'react';
import PropTypes from 'prop-types';
import AdvertLink from "./AdvertLink";
import Advert from "./Advert";
import AdvertNew from "./AdvertNew";
import {injectIntl, defineMessages} from "react-intl";

const messages = defineMessages({
    no_sms: {
        id:"priceLevels.no_sms",
        defaultMessage:"I don't want to receive SMS"
    }
});

class Controls extends React.Component {
    static propTypes = {
        adverts: PropTypes.arrayOf(PropTypes.object).isRequired,
        selectedAdvert: PropTypes.object,
        onProfileTitleSearchChange: PropTypes.func.isRequired,
        priceValuesVoice: PropTypes.array.isRequired,
        priceValuesSms: PropTypes.array.isRequired,
        serviceTypeValues: PropTypes.array.isRequired,
        onAdvertEdit: PropTypes.func.isRequired,
        onAdvertCreate: PropTypes.func.isRequired,
        selectedConversationId: PropTypes.number,
        canCreateAdvert: PropTypes.bool,
        onLoadMoreProfiles: PropTypes.func.isRequired,
        canHaveHappyHours: PropTypes.bool,
    };

    render() {
        const {
            adverts,
            selectedAdvert,
            onProfileTitleSearchChange,
            priceValuesVoice,
            priceValuesSms,
            serviceTypeValues,
            onAdvertEdit,
            onAdvertCreate,
            selectedConversationId,
            canCreateAdvert,
            onLoadMoreProfiles,
            intl,
            canHaveHappyHours
        } = this.props;

        const priceValuesVoiceForView = priceValuesVoice.slice(0);
        priceValuesVoiceForView.unshift({name: '', value: ''});
        const priceValuesSmsForView = priceValuesSms.slice(0);
        priceValuesSmsForView.unshift({
            name:  intl.formatMessage(messages.no_sms),
            value: ''
        });

        return (
            <div className="controls">
                <div className="user">
                    <div className="user__list">
                        {adverts.map(advert => (
                            <AdvertLink advert={advert}
                                        active={selectedAdvert && selectedAdvert.id === advert.id}
                                        key={"advert-link-" + advert.id}
                                        unreadCount={advert.numUnreadProfiles}
                            />
                        ))}

                        <div className="user__item user__item--more">
                            <AdvertNew priceValuesVoice={priceValuesVoiceForView} priceValuesSms={priceValuesSmsForView} serviceTypeValues={serviceTypeValues}
                                       onAdvertCreate={onAdvertCreate} canCreateAdvert={canCreateAdvert}
                            />
                        </div>
                    </div>
                </div>
                {selectedAdvert &&
                <Advert onSearchChange={onProfileTitleSearchChange} advert={selectedAdvert} priceValuesVoice={priceValuesVoiceForView} priceValuesSms={priceValuesSmsForView}
                        serviceTypeValues={serviceTypeValues} onAdvertEdit={onAdvertEdit} canHaveHappyHours={canHaveHappyHours}
                        selectedConversationId={selectedConversationId} onLoadMoreProfiles={() => onLoadMoreProfiles(selectedAdvert.id)}/>
                }
            </div>
        )
    }
}

export default injectIntl(Controls);


// WEBPACK FOOTER //
// ./src/containers/Conversations/Controls/Controls.jsx